import { IEmbedConfiguration } from 'powerbi-client';
import * as pbi from 'powerbi-client';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { NgxPowerBiService } from 'ngx-powerbi';
import { ReportService } from '../shared/report.service';
import { StateService } from '../../core/state-manager/appstateservice';
import { Report } from '../shared/models/ReportModel';
import { AppInsightService } from '../../common/logging/appinsight.service';
@Component({
  selector: 'app-embed-report',
  templateUrl: './embed-report.component.html',
  styleUrls: ['./embed-report.component.scss']
})
export class EmbedReportComponent implements OnInit, OnDestroy {
  public screenHeight: number;
  private powerBiService: NgxPowerBiService;
  config: IEmbedConfiguration;
  private pbiContainerElement: HTMLElement;
  report: Report;
  reportmodel: any;
  pages: pbi.Page[];
  currentPage: pbi.Page;
  @Input() reportName:string;
  @Input() displayOption:string;
  @Input() navigation:boolean;
  @Input() hideVisuals:Array<string>;
  activePage:pbi.Page;
  embedReport:pbi.Report;
  dashboardLoadError:boolean;
  currentUser: any;
  private currentPageName: string = null;
  private currentPageStartTime: number = null;
  private dataSelectedThrottleMap = new Map<string, number>();
  
  constructor(private reportService: ReportService,
              public currentState: StateService,
              private appInsights: AppInsightService) { }

  ngOnInit(): void {
    this.currentUser = this.currentState.getUserData();
    this.BindPowerBiEmbedReport();
  }

  private getBaseTelemetryProperties(): any {
    const userInfo = {user: this.currentUser?.userPrincipalName, id: this.currentUser?.id};
    const reportInfo = {reportName: this.reportName, reportId: this.config.id};
    const currentPage = this.currentPageName;
    return {
      appRole: 'powerbi-embedded',
      report: reportInfo,
      // Removed: reportId, workspaceId, full userId to minimize PII exposure
      user: userInfo,
      currentPage: currentPage
    };
  }

  BindPowerBiEmbedReport()
  {
    this.reportService.getReportObject(this.reportName,-1).subscribe(res => {
      this.reportmodel = res;
      this.config = {
          type: res.reportType,
          id: res.id,
          accessToken: res.embedToken.token,
          embedUrl: res.embedUrl,
          permissions: pbi.models.Permissions.All,
          tokenType: pbi.models.TokenType.Embed,
          viewMode: pbi.models.ViewMode.View,
          pageName:this.activePage?.name,
          settings: {
              filterPaneEnabled: false,
              navContentPaneEnabled: this.navigation,
              layoutType: pbi.models.LayoutType.Custom,
              customLayout: {
                 displayOption: this.displayOption==='FitToWidth' ? pbi.models.DisplayOption.FitToWidth : pbi.models.DisplayOption.FitToPage
              },
          }
      };
      this.pbiContainerElement =  document.getElementById('pbi-container');
      this.powerBiService = new NgxPowerBiService();
      this.powerBiService.reset(this.pbiContainerElement);
      this.embedReport = this.powerBiService.embed(this.pbiContainerElement, this.config) as pbi.Report;
      
      this.embedReport.off('loaded');
      this.embedReport.off('rendered');
      this.embedReport.off('pageChanged');
      this.embedReport.off('buttonClicked');
      this.embedReport.off('visualClicked');
      this.embedReport.off('bookmarkApplied');
      this.embedReport.off('dataSelected');
      this.embedReport.off('error');
      
      this.embedReport.on('loaded', () => {
          this.appInsights.logEvent('PowerBI_ReportLoaded', this.getBaseTelemetryProperties());

              if(this.reportmodel.pageName!==null){
                this.embedReport.setPage(this.reportmodel.pageName).then(() => {
                  // Get displayName after page is set
                  this.embedReport.getPages().then(pages => {
                    const currentPage = pages.find(p => p.name === this.reportmodel.pageName);
                    this.currentPageName = currentPage?.displayName || 'Unknown';
                    this.currentPageStartTime = Date.now();
                  });
                });
            }
            else{
              this.embedReport.getPages().then(pages=>{

                let isSingleSite = false;
                if(this.currentState.isViewAsAdmin()){
                  isSingleSite = this.currentState.getViewingUserData().sites?.length== 1 ? true : false;
                }
                else{
                  if(this.currentUser==null)
                  this.currentUser = this.currentState.getUserData();
                  isSingleSite = this.currentUser?.sites?.length ==1  ? true : false;
                }
                let pageToSet = isSingleSite ? pages[0] : pages[1];
                this.embedReport.setPage(pageToSet.name);
                // Initialize page tracking with displayName (no IDs)
                this.currentPageName = pageToSet.displayName;
                this.currentPageStartTime = Date.now();
              });
        }
          let iframe = this.pbiContainerElement.getElementsByTagName('iframe')[0];
          iframe.setAttribute("frameborder","0");
         }),
       this.embedReport.on('rendered', () => {
         this.appInsights.logEvent('PowerBI_ReportRendered', this.getBaseTelemetryProperties());

       });
       
       this.embedReport.on('pageChanged', (event: any) => {
         const page = event.detail.newPage;
         const pageDisplayName = page.displayName; // Human-readable: "Overview", "Demographics"
         const now = Date.now();
         
         // Calculate duration on previous page
         let durationSeconds = null;
         let previousPage = this.currentPageName;
         
         if (this.currentPageStartTime !== null) {
             durationSeconds = Math.round((now - this.currentPageStartTime) / 1000);
         }
         
         // Update tracking variables - use displayName (no IDs)
         this.currentPageName = pageDisplayName;
         this.currentPageStartTime = now;
         

         
         this.appInsights.logEvent('PowerBI_PageChanged', {
           ...this.getBaseTelemetryProperties(),
           previousPage: previousPage,
           durationSeconds: durationSeconds
         });
       });
       
       this.embedReport.on('buttonClicked', (event: any) => {
         this.appInsights.logEvent('PowerBI_ButtonClicked', {
           ...this.getBaseTelemetryProperties(),
           buttonId: event.detail.id,
           buttonTitle: event.detail.title
         });

       });
       
       this.embedReport.on('dataSelected', (event: any) => {
         const visual = event.detail?.visual;
         const filters = event.detail?.filters;
         const dataPoints = event.detail?.dataPoints;
         

         this.appInsights.logEvent('PowerBI_DataSelected', {
           ...this.getBaseTelemetryProperties(),
           visual: visual?.name,
           filters: filters,
            dataPoints: dataPoints
         });
       });
       this.embedReport.on('visualClicked', (event: any) => {
         const visual = event.detail?.visual;

         
         this.appInsights.logEvent('PowerBI_VisualClicked', {
           ...this.getBaseTelemetryProperties(),
           visual: visual
         });
       });

       this.embedReport.on('bookmarkApplied', (event: any) => {
         const bn = event.detail?.bookmarkName;

          this.appInsights.logEvent('PowerBI_BookmarkApplied', {
            ...this.getBaseTelemetryProperties(),
            bookmarkName: bn
          });
       });
       
       this.embedReport.on('error', (event: any) => {
         console.error('Power BI error:', event.detail);
         this.appInsights.logException(
           new Error(event.detail.message || 'Power BI Error'),
           'PowerBI_Error',
           {
             ...this.getBaseTelemetryProperties(),
             detailedMessage: event.detail.detailedMessage,
             errorCode: event.detail.errorCode,
             httpStatusCode: event.detail.httpStatusCode
           }
         );
       });
  },
  err => {
      console.log(err);
      this.dashboardLoadError = true;
      throw new Error('Exception occured while rendering the dashboard:' + err);
  });
  }

  ngOnDestroy(): void {
    // Log how long user spent on this report before leaving
    if (this.currentPageStartTime !== null && this.reportmodel) {
        const now = Date.now();
        const totalDurationSeconds = Math.round((now - this.currentPageStartTime) / 1000);
        

        
        this.appInsights.logEvent('PowerBI_ReportExited', {
            ...this.getBaseTelemetryProperties(),
            lastPageViewed: this.currentPageName,
            totalDurationSeconds: totalDurationSeconds,
            exitReason: 'navigation'
        });
    }
    
    if (this.pbiContainerElement) {
      this.powerBiService.reset(this.pbiContainerElement);
    }
    this.dataSelectedThrottleMap.clear();
  }
}

